export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    secondHeaderLogo: string;
    contactUsText: string;
    footerLogo: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    uninsuredProgramId: string;
    surveyId: string;

    insuredPathQuestionId: string;
    insuredPathAnswerId: string;

    insuredPathSurveyId: string;
    insuredEligibilityFederalQuestion: string;
    insuredEligibilityFederalAnswer: string;
    insuredEligibilityCitizenQuestion: string;
    insuredEligibilityCitizenAnswer: string;

    insuredEligibilityAgeQuestion: string;
    insuredEligibilityAgeAnswerYes: string;
    insuredEligibilityAgeAnswerNo: string;

    insuredEligibilitySubsidizedHealthcareQuestion: string;
    insuredEligibilitySubsidizedHealthcareAnswerYes:string;
    insuredEligibilitySubsidizedHealthcareAnswerNo:string;

    insuredEligibilityIsPrescribedOmnitropeQuestion: string;
    insuredEligibilityIsPrescribedOmnitropeAnswerYes: string;
    insuredEligibilityIsPrescribedOmnitropeAnswerNo: string;

    insuredEligibilityLabelIndication: string;

    insuredEligibilityLabelIndicationGHD: string;
    insuredEligibilityLabelIndicationISS : string;
    insuredEligibilityLabelIndicationSGA : string;
    insuredEligibilityLabelIndicationTS : string;
    insuredEligibilityLabelIndicationPWS : string;
    insuredEligibilityLabelIndicationGHD2 : string;

    insuredPatientAuthAttestation: string;

    insuredPatientAuthAttestationTrue: string;
    insuredPatientAuthAttestationFalse: string;

    insuredPatientAuthFirstName: string;
    insuredPatientAuthLastName: string;

    insuredPatientAuthDate: string;

    uninsuredPathQuestionId: string;
    uninsuredPathAnswerId: string;

    uninsuredOfferQuestionId: string;
    uninsuredOfferAnswerId: string;

    uninsuredEligibilityFederalQuestion: string;
    uninsuredEligibilityFederalAnswer: string;
    uninsuredEligibilityCitizenQuestion: string;
    uninsuredEligibilityCitizenAnswer: string;

    uninsuredEligibilityAgeQuestion: string;
    uninsuredEligibilityAgeAnswerYes: string;
    uninsuredEligibilityAgeAnswerNo: string;

    uninsuredEligibilitySubsidizedHealthcareQuestion: string;
    uninsuredEligibilitySubsidizedHealthcareAnswerYes:string;
    uninsuredEligibilitySubsidizedHealthcareAnswerNo:string;


    uninsuredPatientAuthAttestation: string;
    uninsuredPatientAuthAttestationTrue: string;
    uninsuredPatientAuthAttestationFalse: string;

    uninsuredPatientAuthFirstName: string;
    uninsuredPatientAuthLastName: string;

    uninsuredPatientAuthDate: string;

    uninsuredEligibilityIsPrescribedOmnitropeQuestion: string;
    uninsuredEligibilityIsPrescribedOmnitropeAnswerYes: string;
    uninsuredEligibilityIsPrescribedOmnitropeAnswerNo: string;
    uninsuredEligibilityLabelIndication: string;
    uninsuredEligibilityLabelIndicationGHD: string;
    uninsuredEligibilityLabelIndicationISS : string;
    uninsuredEligibilityLabelIndicationSGA : string;
    uninsuredEligibilityLabelIndicationTS : string;
    uninsuredEligibilityLabelIndicationPWS : string;
    uninsuredEligibilityLabelIndicationGHD2 : string;



    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
}
